<script>
import { reactive } from '@vue/composition-api'

export default {
  props: {
    action: Function,
    payload: Object
  },

  setup (props, { slots }) {
    const trigger = () => {
      const result = props.action(props.payload)
      if (result && typeof result?.then === 'function' && result[Symbol.toStringTag] === 'Promise') {
        state.loading = true
        result.then(() => {
          state.loading = false
        }).catch(error => {
          console.error(error.message)
          state.loading = false
        })
      }
    }

    const state = reactive({
      trigger,
      loading: false
    })

    return () => slots.default(state)
  }
}
</script>
